<template>
  <!-- 
  1.화면ID      : MCF_BT_001
  2.화면명      : 배치 프로시저 관리
  3.작성자      : 김찬종 차장
  4.화면설명    : 배치 프로시저 실행이력을 조회한다.
  5.Descrition : 2024.04.02 최초작성
  * A Copyright Notice : Copyright 2024 SNC.CO All rights reserved
  -->
  <div class="content-wrap">
    <div>
      <!-- 검색 영역 시작 -->
      <div class="search-wrap">
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="프로시저명">
                <template v-slot:end="slotProps">
                  <ElInput :id="slotProps.id" v-model="state.searchParams.proc_nm"  @inputKeyupEnter="onSearch"/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="프로시저설명">
                <template v-slot:end="slotProps">
                  <ElInput :id="slotProps.id" v-model="state.searchParams.proc_desc" @inputKeyupEnter="onSearch"/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-2">
            <div class="mb-3">
              <ElLabel name="성공여부">
                <template #end>
                  <ElSelect v-model="state.searchParams.success_yn" :options="state.sucYnList"/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-2">
            <div class="mb-3">
              <ElLabel name="사용여부">
                <template #end>
                  <ElSelect v-model="state.searchParams.use_yn" :options="state.useYnList"/>
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
      </div>
      <!-- 검색 영역 종료 -->
      <div class="search-detail-wrap"></div>
      <div class="text-end py-2">
        <ElButton type="search" @buttonClick="onSearch()">검색</ElButton>
      </div>
      <!-- 그리드 영역 시작 -->
      <div class="table-responsive table-list">
        <DataTable
            :value="state.gridRowData"
            v-model:selection="state.selectRow" selectionMode="single"
            paginator :rows="20" :rowsPerPageOptions="[10, 20, 50, 100, 200]" 
            scrollable scrollHeight="400px"
            stripedRows
            @rowSelect="onRowSelect">
            <template #empty> <div class="center">데이터가 존재하지 않습니다.</div> </template>
            <Column field="row_no" header="NO" style="min-width:4rem"></Column>
            <Column field="proc_nm" header="프로시저명" style="min-width:12rem"></Column>
            <Column field="proc_desc" header="프로시저설명" style="min-width:12rem"></Column>
            <Column field="cron_express" header="실행주기" style="min-width:8rem"></Column>
            <Column field="prev_dt" header="이전 시행일자" style="min-width:11rem; text-align:center"></Column>
            <Column field="schd_dt" header="다음 실행일자" style="min-width:11rem; text-align:center "></Column>
            <Column field="success_yn" header="성공여부" style="min-width:5rem; text-align:center"></Column>
            <Column field="use_yn" header="사용여부" style="min-width:5rem; text-align:center"></Column>
        </DataTable>
      </div>
      <!-- 그리드 영역 종료 -->
      <div class="text-end py-3">
        <ElButton type="primary" @buttonClick="$router.push('/cf/MCF_BT_002')">등록</ElButton>
      </div>
    </div>
  </div>
</template>
     
<script setup>   
  import {reactive,ref,onBeforeMount,onMounted,computed} from 'vue';
  import DatePicker     from '@/components/common/DatePicker';
  import common         from '@/js/common';
  import DataTable      from 'primevue/datatable';
  import Column         from 'primevue/column';
  import vueRouterCmn   from '@/js/vueRouterCmn';
 
  import { useLoading } from '@/composable/Loading.js'
  const { setIsLoading } = useLoading()
  import { procCronList } from '@/api/batch';
  onBeforeMount(() => {

  });

  onMounted(async () => {
    state.searchParams.success_yn = "All";
    state.searchParams.use_yn = "All";

    await onSearch();
  });

  //변수 선언 영역 
  const state = reactive({
      gridRowData : [],
      selectRow : null,
      searchParams : {
          proc_nm    : '',
          proc_desc  : '',
          success_yn : '',
          use_yn     : '',
          page_count : 1,
          unit_count : 100000
      },
      sucYnList : [
                  {text: '전체', value: 'All'},
                  {text: '성공', value: 'Y'},
                  {text: '실패', value: 'N'}
                ],
      useYnList : [
                  {text: '전체', value: 'All'},
                  {text: '사용', value: 'Y'},
                  {text: '미사용', value: 'N'}
                ]
  });

  const onSearch = async () => {
    try {
      setIsLoading(true)
      const res = await procCronList(state.searchParams)
      state.gridRowData = res.rtn;
    } catch (err) {
      alert("전송 중 에러가 발생하였습니다.");
    } finally {
      setIsLoading(false)
    }
  };
  
  const onRowSelect = (event) => {
      if(event.type == 'row') {
        vueRouterCmn.routerPush('MCF_BT_002', {proc_id : event.data.proc_id})
      }
  };
</script>
